import { descreveFalha } from "../../helpers/erroMeta";

// Alerta de conta (toast) uma vez por conexao por montagem da lista.
// `jaAlertadas` e mutado: a conexao entra no Set na primeira falha de conta.
export const deveAlertarFalhaDeConta = (jaAlertadas, message) => {
  if (!message || message.ack !== -1) return false;
  const { marcaConexao } = descreveFalha(message);
  if (!marcaConexao) return false;
  const whatsappId = message.whatsappId ?? message.ticket?.whatsappId;
  if (whatsappId === null || whatsappId === undefined) return false;
  if (jaAlertadas.has(whatsappId)) return false;
  jaAlertadas.add(whatsappId);
  return true;
};
